import {
  Placeholder,
  Text,
  TextField,
  withDatasourceCheck,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from '../../../hooks/helpers';

type Fields = {
  title: TextField;
  description: TextField;
};

type ListingHeroSectionProps = ComponentProps & {
  fields: Fields;
};

const ListingHeroSection = ({ rendering, fields }: ListingHeroSectionProps): JSX.Element => {
  const { anchorId, backgroundClass } = useHelpers(rendering);
  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className={`py-xl-8 py-md-5 py-3 ${backgroundClass}`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-12">
            <Text tag="h1" field={fields?.title} className="background-to-change" />
            <Text
              tag="p"
              field={fields?.description}
              className="body-large mt-2 text-grey background-to-change"
            />
          </div>
          <div className="col-xl-4 ms-auto d-none-if-empty">
            <Placeholder name="abrdn-banner-quick-links" rendering={rendering} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default withDatasourceCheck()<ListingHeroSectionProps>(ListingHeroSection);
